import { Card, CardBody } from '@material-tailwind/react'
import AgamiMediaStatus from './AgamiMediaStatus'
import { AgamiSpot } from '../types/supabase'
import { AgamiCardDetails } from './AgamiCardDetails'

interface SharedAgamiCardProps {
  spot: AgamiSpot
}

/**
 * An agami inside an experience someone shared with you. It shares the safe
 * metadata body of the owner's card, but none of its interactions.
 *
 * ⚠️ Deliberately NOT a reuse of AgamiPreviewCard. That wrapper carries
 * deletion, removal, navigation, QR code and media download. The content belongs
 * to the owner (D9), so those actions must not exist in the recipient tree.
 *
 * The card is not clickable on purpose: there is no agami detail a recipient can
 * open.
 */
const SharedAgamiCard: React.FC<SharedAgamiCardProps> = ({ spot }) => (
  <Card className="w-full h-full" data-testclass="shared-agami-card">
    <CardBody className="flex flex-col h-full">
      <AgamiCardDetails spot={spot} nameTestClass="shared-agami-card-name" />

      <AgamiMediaStatus
        spot={spot}
        playerClassName="w-[130%] ml-[-15%] h-6 mt-auto pt-2 scale-75"
        alertClassName="w-full py-2 px-4 mt-auto text-xs"
        playerTestClass="shared-agami-card-player"
        showIntentionalNone={false}
      />
    </CardBody>
  </Card>
)

export default SharedAgamiCard
